import React from 'react';

const NumberBox = ({ digit, size, mode }) =>
    <div className={`roll-number ${size} ${mode}`}>
        <span className={`roll-number__numbers ${mode}`}>{digit}</span>
    </div>;

export default NumberBox;
